import { Modal, Badge, ListGroup, Row, Col } from 'react-bootstrap';

interface DetalhesContaModalProps {
    show: boolean;
    conta: any;
    onClose: () => void;
}

export default function DetalhesContaModal({ show, conta, onClose }: DetalhesContaModalProps) {
    if (!conta) return null;

    return (
        <Modal show={show} onHide={onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Detalhes da Conta de Serviço</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-4">
                    <h5>{conta.descricao}</h5>
                    <p className="text-muted mb-1">
                        <small>Client ID: {conta.clientId}</small>
                    </p>
                    <Badge bg={conta.status === 'ATIVA' ? 'success' : conta.status === 'APROVADO' ? 'warning' : 'secondary'}>
                        {conta.status}
                    </Badge>
                    {conta.acessoMultiUnidade && (
                        <Badge bg="danger" className="ms-2">
                            Acesso Multi-Unidade
                        </Badge>
                    )}
                </div>

                <ListGroup variant="flush">
                    <ListGroup.Item>
                        <Row>
                            <Col xs={4} className="text-muted">
                                🛡️ Perfil
                            </Col>
                            <Col>
                                <Badge bg="primary">{conta.perfilNome || 'INTEGRACAO'}</Badge>
                            </Col>
                        </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                        <Row>
                            <Col xs={4} className="text-muted">
                                🏢 Unidade
                            </Col>
                            <Col>{conta.unidadeId}</Col>
                        </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                        <Row>
                            <Col xs={4} className="text-muted">
                                📅 Data Criação
                            </Col>
                            <Col>{new Date(conta.dataCriacao).toLocaleString('pt-BR')}</Col>
                        </Row>
                    </ListGroup.Item>

                    {conta.dataAprovacao && (
                        <ListGroup.Item>
                            <Row>
                                <Col xs={4} className="text-muted">
                                    📅 Data Aprovação
                                </Col>
                                <Col>{new Date(conta.dataAprovacao).toLocaleString('pt-BR')}</Col>
                            </Row>
                        </ListGroup.Item>
                    )}

                    {conta.dataExpiracao && (
                        <ListGroup.Item>
                            <Row>
                                <Col xs={4} className="text-muted">
                                    ⏰ Data Expiração
                                </Col>
                                <Col>
                                    {new Date(conta.dataExpiracao).toLocaleString('pt-BR')}
                                    {new Date(conta.dataExpiracao) < new Date() && (
                                        <Badge bg="danger" className="ms-2">Expirado</Badge>
                                    )}
                                </Col>
                            </Row>
                        </ListGroup.Item>
                    )}

                    {conta.dataAtualizacao && (
                        <ListGroup.Item>
                            <Row>
                                <Col xs={4} className="text-muted">
                                    📅 Última Atualização
                                </Col>
                                <Col>{new Date(conta.dataAtualizacao).toLocaleString('pt-BR')}</Col>
                            </Row>
                        </ListGroup.Item>
                    )}
                </ListGroup>
            </Modal.Body>
        </Modal>
    );
}
